export default __webpack_public_path__ + "static/media/vedomy.37d409ab.png";